/*
 * Join us CTA fixed button
 */
class RLM_JoinUsCta {
    constructor (wrapper) {
        this.mainWrapper = jQuery(wrapper);
        
        if (!this.mainWrapper.find('#join-us-cta').length) {
            return;
        }
        
        this.instanceID = wrapper;
        this.initState();
        this.initEvents();
    }

    initState () {
        this.button = this.mainWrapper.find('#join-us-cta');
        this.isVisible = true;
        this.win = jQuery(window);
        this.winHeight = this.win.outerHeight();
        this.border = this.mainWrapper.find('#career-block').offset().top - 100;
    }

    initEvents () {
        this.win.on('scroll.cta', this.scroll.bind(this));
        this.win.on('resize.cta', this.resize.bind(this));
        this.win.trigger('scroll');
    }

    scroll () {
        if (!this.isVisible && this.win.scrollTop() + this.winHeight < this.border) {
            this.button.removeClass('is-hidden');
            this.isVisible = true;
        } else if (this.isVisible && this.win.scrollTop() + this.winHeight >= this.border) {
            this.button.addClass('is-hidden');
            this.isVisible = false;
        }
    }

    resize () {
        this.winHeight = this.win.outerHeight();
        this.border = this.mainWrapper.find('#career-block').offset().top - 100;
        this.win.trigger('scroll');
    }

    clear () {
        if (this.win) {
            this.win.off('scroll.cta');
            this.win.off('resize.cta');
        }
    }
}

new RLM_JoinUsCta(document.body);